import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "card border-0",
  style: {"width":"100%"},
  "data-aos": "fade-left"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "svg-icon svg-icon-1 position-absolute ms-2" }
const _hoisted_5 = { class: "border border-primary bg-light rounded-2" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "d-flex ms-4 justify-content-en" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex ms-4 justify-content-en"
}
const _hoisted_9 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_3",
  ref: "closeHexModal"
}
const _hoisted_10 = { class: "modal-dialog" }
const _hoisted_11 = { class: "modal-content roundeda" }
const _hoisted_12 = { class: "modal-body p-15" }
const _hoisted_13 = { class: "row align-middle" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "row my-3" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["value", "selected"]
const _hoisted_18 = { class: "row align-middle" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "row align-middle" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "row align-middle" }
const _hoisted_23 = { class: "d-flex flex-column mb-7 fv-row p-0" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "row align-middle" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "row align-middle" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["value", "selected"]
const _hoisted_30 = { class: "row align-middle" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["value", "selected"]
const _hoisted_33 = { class: "row align-middle" }
const _hoisted_34 = {
  key: 0,
  class: "modal-footer"
}
const _hoisted_35 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_4",
  ref: "closeHexModal"
}
const _hoisted_36 = ["title"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  key: 0,
  title: "True",
  class: /*@__PURE__*/_normalizeClass(`badge badge-light-success`),
  style: {"margin-left":"1.3rem"}
}
const _hoisted_39 = {
  key: 1,
  class: /*@__PURE__*/_normalizeClass(`badge badge-light-success ms-3`),
  title: "False"
}
const _hoisted_40 = {
  key: 0,
  title: "True",
  class: /*@__PURE__*/_normalizeClass(`badge badge-light-success`),
  style: {"margin-left":"1.3rem"}
}
const _hoisted_41 = {
  key: 1,
  class: /*@__PURE__*/_normalizeClass(`badge badge-light-success ms-3`),
  title: "False"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Vue3JsonEditor = _resolveComponent("Vue3JsonEditor")!
  const _component_KTDatatable = _resolveComponent("KTDatatable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
          ]),
          _createElementVNode("span", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              type: "text",
              "data-kt-subscription-table-filter": "search",
              class: "form-control form-control-solid w-250px ps-5",
              placeholder: "Search Webhooks",
              style: {"padding-left":"2.5rem !important"}
            }, null, 544), [
              [_vModelText, _ctx.search]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "d-flex justify-content-end" }, null, -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_4",
              onClick: _cache[2] || (_cache[2] = ($event: any) => {
              {
                _ctx.edit = false;
                _ctx.view = false;
              }
            })
            }, " Look Up ")
          ]),
          (_ctx.permissions.includes('add-webhook'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#kt_modal_3",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => {
              {
                _ctx.edit = false;
                _ctx.view = false;
              }
            })
                }, " Add Webhook ")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "modal-header bg-primary roundeda" }, [
            _createElementVNode("span", { class: "modal-title text-white h5 text-uppercase ms-3" }, "Add Webhook"),
            _createElementVNode("div", {
              class: "btn btn-icon btn-sm",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              id: "webhooks-close-modal",
              style: {"border-radius":"50px"}
            }, [
              _createElementVNode("i", {
                class: "bi bi-x-circle-fill light-text fs-3",
                style: {"color":"white"}
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-primary fs-4 font-weight-bold" }, "Name:", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.payload.name) = $event)),
                class: "form-control my-3",
                placeholder: "Enter Name",
                disabled: _ctx.view
              }, null, 8, _hoisted_14), [
                [_vModelText, _ctx.payload.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-primary fs-4 font-weight-bold" }, "Select Company:", -1)),
              _createElementVNode("select", {
                class: "form-select form-select-solid border",
                "data-control": "select2",
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onCustomerChange && _ctx.onCustomerChange(...args))),
                "data-dropdown-parent": "#kt_modal_1",
                "data-placeholder": "Select an option",
                "data-allow-clear": "true",
                disabled: _ctx.view
              }, [
                _cache[16] || (_cache[16] = _createElementVNode("option", { value: "" }, "All", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (customer, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: customer.id,
                    selected: customer.id == _ctx.payload.se_account_id
                  }, _toDisplayString(customer.name + " (ID: " + customer.id + ")"), 9, _hoisted_17))
                }), 128))
              ], 40, _hoisted_16)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-primary fs-4 font-weight-bold" }, "HTTPS Endpoint:", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payload.url) = $event)),
                class: "form-control my-3",
                placeholder: "HTTPS Endpoint",
                disabled: _ctx.view
              }, null, 8, _hoisted_19), [
                [_vModelText, _ctx.payload.url]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-primary fs-4 font-weight-bold" }, "API KEY:", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.payload.api_key) = $event)),
                class: "form-control my-3",
                placeholder: "API KEY",
                disabled: _ctx.view
              }, null, 8, _hoisted_21), [
                [_vModelText, _ctx.payload.api_key]
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "text-primary fs-4 font-weight-bold" }, "Sensor Type", -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select form-select-solid border border-primary",
                  "data-control": "select2",
                  "data-hide-search": "true",
                  "data-placeholder": "Select Type",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.payload.sensor_types_id) = $event)),
                  disabled: _ctx.view
                }, _cache[20] || (_cache[20] = [
                  _createStaticVNode("<option value=\"\">Select Type</option><option value=\"1\">Bins</option><option value=\"2\">Tracker</option><option value=\"3\">Vision</option><option value=\"4\">Tilt</option><option value=\"5\">V2 (New Server)</option>", 6)
                ]), 8, _hoisted_24), [
                  [_vModelSelect, _ctx.payload.sensor_types_id]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-primary fs-4 font-weight-bold" }, "API KEY Header:", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-solid border",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.payload.api_key_header) = $event)),
                "data-control": "select-api_key_header",
                "data-dropdown-parent": "#kt_modal_1",
                "data-placeholder": "Select an option",
                "data-allow-clear": "true",
                disabled: _ctx.view
              }, _cache[22] || (_cache[22] = [
                _createElementVNode("option", { value: "default" }, "Default", -1),
                _createElementVNode("option", { value: "device" }, "Device", -1)
              ]), 8, _hoisted_26), [
                [_vModelSelect, _ctx.payload.api_key_header]
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-primary fs-4 font-weight-bold" }, "Decoder:", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-solid border",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.payload.is_decoded) = $event)),
                "data-control": "select-decoder",
                "data-dropdown-parent": "#kt_modal_1",
                "data-placeholder": "Select an option",
                "data-allow-clear": "true",
                disabled: _ctx.view
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.webhooks_decoder, (hook, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: hook.value,
                    selected: hook.value == _ctx.payload.is_decoded
                  }, _toDisplayString(hook.name), 9, _hoisted_29))
                }), 128))
              ], 8, _hoisted_28), [
                [_vModelSelect, _ctx.payload.is_decoded]
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-primary fs-4 font-weight-bold" }, "Enable Custom Payload:", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-solid border",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.payload.is_custom_payload) = $event)),
                "data-control": "select-decoder",
                "data-dropdown-parent": "#kt_modal_1",
                "data-placeholder": "Select an option",
                "data-allow-clear": "true",
                disabled: _ctx.view
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.webhooks_decoder, (hook, i) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: i,
                    value: hook.value,
                    selected: hook.value == _ctx.payload.is_custom_payload
                  }, _toDisplayString(hook.name), 9, _hoisted_32))
                }), 128))
              ], 8, _hoisted_31), [
                [_vModelSelect, _ctx.payload.is_custom_payload]
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-primary fs-4 font-weight-bold" }, "Custom Payload:", -1)),
              _createVNode(_component_Vue3JsonEditor, {
                modelValue: _ctx.payload.payload,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.payload.payload) = $event)),
                "show-btns": false,
                expandedOnStart: true,
                mode: 'code',
                onJsonChange: _ctx.onJsonChange,
                disabled: _ctx.view
              }, null, 8, ["modelValue", "onJsonChange", "disabled"])
            ])
          ]),
          (!_ctx.view)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _cache[27] || (_cache[27] = _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  "data-bs-dismiss": "modal"
                }, " Close ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.saveDownlink && _ctx.saveDownlink(...args))),
                  class: "btn btn-primary"
                }, " Save changes ")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_35, _cache[29] || (_cache[29] = [
      _createStaticVNode("<div class=\"modal-dialog\"><div class=\"modal-content roundeda\"><div class=\"modal-header bg-primary roundeda\"><span class=\"modal-title text-white h5 text-uppercase ms-3\">Available Data Fields</span><div class=\"btn btn-icon btn-sm\" data-bs-dismiss=\"modal\" aria-label=\"Close\" id=\"webhooks-close-modal\" style=\"border-radius:50px;\"><i class=\"bi bi-x-circle-fill light-text fs-3\" style=\"color:white;\"></i></div></div><div class=\"modal-body p-15\"><table class=\"table lookup\"><thead><tr><th scope=\"col\">Key</th><th scope=\"col\">Details</th></tr></thead><tbody><tr><td>{data}</td><td>Contain Payload</td></tr><tr><td>{time}</td><td>Uplink time</td></tr><tr><td>{X_Axis}</td><td>Device orientation</td></tr><tr><td>{Y_Axis}</td><td>Device orientation</td></tr><tr><td>{Z_Axis}</td><td>Device orientation</td></tr><tr><td>{device}</td><td>Contain Device Id</td></tr><tr><td>{uplink}</td><td>Contain Uplink Type</td></tr><tr><td>{battery}</td><td>Contain Battery value in Percentage (%)</td></tr><tr><td>{Distance}</td><td>Raw Distance</td></tr><tr><td>{fireAlarm}</td><td>Contain value of fireAlarm Enable/Disable</td></tr><tr><td>{pickupType}</td><td>Contain value of pickupType</td></tr><tr><td>{pickupEvent}</td><td>Contain value of pickupEvent</td></tr><tr><td>{tamperEvent}</td><td>If Device Position is changed</td></tr><tr><td>{temperature}</td><td>Temperature of Bin</td></tr><tr><td>{seqNumber}</td><td>Sequence Number</td></tr></tbody></table></div></div></div>", 1)
    ]), 512),
    _createVNode(_component_KTDatatable, {
      style: {"margin-left":"30px !important"},
      "table-data": _ctx.data,
      total: _ctx.total,
      "table-header": _ctx.headerConfig,
      "enable-items-per-page-dropdown": true,
      loading: _ctx.loading,
      rowsPerPage: _ctx.pagination.page_size,
      onCurrentChange: _ctx.currentChange,
      onItemsPerPageChange: _ctx.itemsPerPageChange
    }, {
      "cell-name": _withCtx(({ row: data }) => [
        _createTextVNode(_toDisplayString(data.name), 1)
      ]),
      "cell-customer_name": _withCtx(({ row: data }) => [
        _createTextVNode(_toDisplayString(data.customer_name || "N/A"), 1)
      ]),
      "cell-url": _withCtx(({ row: data }) => [
        (data.url && data.url.length > 35)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              title: data.url
            }, _toDisplayString(data.url.slice(0, 35) + "..."), 9, _hoisted_36))
          : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(data.url), 1))
      ]),
      "cell-api_key": _withCtx(({ row: data }) => [
        _createTextVNode(_toDisplayString(data.api_key), 1)
      ]),
      "cell-is_decoded": _withCtx(({ row: data }) => [
        (data.is_decoded == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, _cache[30] || (_cache[30] = [
              _createElementVNode("i", { class: "fas fa-check text-primary" }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_39, _cache[31] || (_cache[31] = [
              _createElementVNode("i", { class: "bi bi-x-circle text-danger" }, null, -1)
            ])))
      ]),
      "cell-is_custom_payload": _withCtx(({ row: data }) => [
        (data.is_custom_payload == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, _cache[32] || (_cache[32] = [
              _createElementVNode("i", { class: "fas fa-check text-primary" }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_41, _cache[33] || (_cache[33] = [
              _createElementVNode("i", { class: "bi bi-x-circle text-danger" }, null, -1)
            ])))
      ]),
      "cell-action": _withCtx(({ row: data }) => [
        _createTextVNode(_toDisplayString(data.action) + " ", 1),
        _createElementVNode("div", {
          class: _normalizeClass(`badge badge-light-success pointer`),
          "data-bs-toggle": "modal",
          "data-bs-target": "#kt_modal_3",
          onClick: ($event: any) => (_ctx.viewWebhook(data))
        }, _cache[34] || (_cache[34] = [
          _createElementVNode("i", { class: "far fa-eye text-primary" }, null, -1)
        ]), 8, _hoisted_42),
        (_ctx.permissions.includes('edit-webhook'))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`badge badge-light-success pointer ms-3`),
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_3",
              onClick: ($event: any) => (_ctx.editWebhook(data))
            }, _cache[35] || (_cache[35] = [
              _createElementVNode("i", { class: "fas fa-edit text-success" }, null, -1)
            ]), 8, _hoisted_43))
          : _createCommentVNode("", true),
        (_ctx.permissions.includes('delete-webhook'))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(`badge badge-light-success ms-3 pointer`),
              onClick: ($event: any) => (_ctx.deleteHook(data.id))
            }, _cache[36] || (_cache[36] = [
              _createElementVNode("i", { class: "fas fa-trash text-danger" }, null, -1)
            ]), 8, _hoisted_44))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["table-data", "total", "table-header", "loading", "rowsPerPage", "onCurrentChange", "onItemsPerPageChange"])
  ], 64))
}